import React, { useState, Component } from 'react';
import NavButton from '../Atoms/NavButton';
import Button from '../Atoms/Button';

import {isMobile} from 'react-device-detect';

function NavBar(props) {
  
  //   let [toggle, setToggle] = useState(false);

  //   const onToggleChange = (checked) => {
  //     setToggle(checked);
  // }
    

    return <nav className={`main-navigation flex items-top phone-h-50 flex-column ${props.fullWidth ? 'w-100 bb' : 'w-10 bl tablet-w-20 phone-w-25'}`} >
        {/* <NavButton content="KONTAKT" link="kontakt" cx={`flex justify-content-center items-center br-100 circle-10 tablet-circle-30 phone-circle-20 ${props.fullWidth ? '' : 'ba'}`} rotated={false}/> */}
        {/* <NavButton content="CV" link="cv" cx={`flex justify-content-center items-center br-100 circle-10 tablet-circle-30 phone-circle-20 ${props.fullWidth ? '' : 'ba'}`} rotated={false}/>
        <NavButton content="OM" link="om" cx={`flex justify-content-center items-center br-100 circle-10 tablet-circle-30 phone-circle-20 ${props.fullWidth ? '' : 'ba'}`} rotated={false}/> */}
        
        
        <NavButton content="KONTAKT" link="kontakt" cx={`flex justify-content-center items-center br-100  ${props.fullWidth ? '' : 'ba'}`} outerCx={`${isMobile ? null : "bb"}`} rotated={false} fullWidth={props.fullWidth}/>
        <NavButton content="CV" link="cv" cx={`flex justify-content-center items-center br-100  ${props.fullWidth ? '' : 'ba'}`} outerCx={`${isMobile ? null : "bb"}`} rotated={false} fullWidth={props.fullWidth}/>
        <NavButton content="OM" link="om" cx={`flex justify-content-center items-center br-100 ${props.fullWidth ? '' : 'ba'}`}  outerCx={"bb"} rotated={false} fullWidth={props.fullWidth}/>

        
          <Button  externalLink="https://www.facebook.com/profile.php?id=100009001271613" content="FACEBOOK"  cx={`flex bb flex-basis-100 justify-content-center items-center ${props.fullWidth ? "h-5 tablet-h-12" : null }` } rotated={false} hasIcon={true} icon="▶"/>
          <Button  externalLink="https://www.instagram.com/sonjalillebaek/" content="INSTAGRAM"  cx={`flex w-100 flex-basis-100 justify-content-center items-center ${props.fullWidth ? "h-5 tablet-h-12 " : null }`} rotated={false} hasIcon={true} icon="▶"/>
        
        
      </nav>
    
  
}

export default NavBar;